<template>
  <!-- <v-container v-if="preloader">
    <div class="text-center">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
  </v-container> -->
  <div class="row">
    <div class="col-12 mt-0 pt-0">
      <div class="flexBlock pd-block">
        <h3 class="custom-h3">История оценок</b></h3>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest"
export default {
  name: "MarksHistory",
  components: {
    GlobalRequest
  },
  props: {},
  data() {
    return {
      preloader: true,
    };
  },

  computed: {
  },

  watch: {
  },

  methods: {
  },
};
</script>

<style scoped>
</style>
